const BASE_URL = 'https://api.dev.auxo.dk/public';

/**
 * Helper to fetch a single entry by slug (localized in Danish 'da')
 */
export async function fetchBySlug(slug) {
  try {
    const res = await fetch(`${BASE_URL}/by-slug/da/${slug}`);
    if (!res.ok) {
      if (res.status === 404) return null;
      throw new Error(`Failed to fetch by slug: ${slug}`);
    }
    return await res.json();
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Helper to fetch a list of entries from a collection
 */
export async function fetchCollection(collectionName, params = {}) {
  try {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        query.append(key, val);
      }
    });
    
    const queryString = query.toString();
    const url = `${BASE_URL}/v2/content/${collectionName}${queryString ? `?${queryString}` : ''}`;
    
    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(`Failed to fetch collection: ${collectionName}`);
    }
    return await res.json();
  } catch (err) {
    console.error(err);
    return { items: [], total: 0, limit: 25, offset: 0 };
  }
}

/**
 * Fetch a page by slug
 */
export async function fetchPage(slug) {
  return await fetchBySlug(slug);
}

/**
 * Fetch a gallery by slug from the galleries collection
 */
export async function fetchGallery(slug) {
  try {
    const res = await fetchCollection('galleries');
    const gallery = res.items.find(item => item.slug === slug || item.slug?.da === slug);
    return gallery || null;
  } catch (err) {
    console.error(err);
    return null;
  }
}

/**
 * Fetch all cases
 */
export async function fetchCases() {
  const res = await fetchCollection('cases', { limit: 100 });
  return res.items;
}

/**
 * Fetch all team members sorted by order
 */
export async function fetchTeamMembers() {
  const res = await fetchCollection('team_members', { limit: 100 });
  return res.items.sort((a, b) => (a.order || 0) - (b.order || 0));
}

/**
 * Fetch all timeline events sorted by order
 */
export async function fetchTimelineEvents() {
  const res = await fetchCollection('timeline_events', { limit: 100 });
  return res.items.sort((a, b) => (a.order || 0) - (b.order || 0));
}
